import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import Button from '../../components/Buttons/Button';
import DataTable from '../../components/DataTable/DataTable';
import { IColInfo } from '../../components/DataTable/Interfaces';
import ButtonBar from '../../components/Fields/ButtonBar';
import Form from '../../components/Fields/Form';
import TextboxField from '../../components/Fields/TextboxField';
import { FormConfig } from '../../components/Fields/Types';
import { useLocalStorage } from '../../components/Hooks/LocalStorageHook/useLocalStorage';
import useValidation from '../../components/Hooks/ValidationHook/useValidation';
import { ApplicationFunctions, useAuth } from '../../contexts/authContext';
import { useNotifications } from '../../contexts/notificationContext';
import ColorModel from '../../models/ColorModel';
import SearchCriteria from '../../models/common/SearchCriteria';
import DataService from "../../services/data.service";
import Colors_popup_AddColor from './Popups/Colors_popup_AddColor';

const Colors: React.FC = () => {
    const [data, setData] = useState<ColorModel[]>();
    const [showPopup, setShowPopup] = useState<boolean>(false);
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedFor } = useAuth();
    const [formData, setFormData] = useLocalStorage<SearchCriteria>("colorsFilter", { quickSearch: '' })

    useEffect(() => {
        getTableData(formData);
    }, []);

    function search() {
        if (formData.quickSearch.length >= 3)
            getTableData(formData)
    }

    function setDefaultCriteria() {
        setFormData({ quickSearch: '' })
        getTableData({ quickSearch: '' })
    }

    function getTableData(searchCriteria: SearchCriteria) {
        DataService.post<ColorModel[]>('api/v1/Colors/Search', searchCriteria)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/Colors/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData(formData);
            })
            .catch(e => { handleException(e); });
    }

    function getColorCode(color: ColorModel, colInfo: IColInfo): string | undefined {
        return color.colorCode;
    }
    function getTextColorCode(color: ColorModel, colInfo: IColInfo): string | undefined {
        if (color.textColorCode)
            return color.textColorCode;

        return '#212529'
    }

    const formConfig: FormConfig = {
        fields: [{ name: 'quickSearch', label: 'Search' }],
        handleFieldChanged: search,
        handleSubmit: () => getTableData(formData),
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData);

    const colInfos: IColInfo[] = [
        { title: 'ID', key: true, dataProp: 'id', dataType: 'number' },
        { title: 'Abbreviation', dataProp: 'abbreviation', filterInfo: { filterType: 'Textbox' } },
        { title: 'Name', dataProp: 'name', filterInfo: { filterType: 'Textbox' } },
        { title: 'ColorCode', dataProp: 'colorCode', getCellBackgroundColor: getColorCode, getCellTextColor: getTextColorCode },
        { title: 'Sort order', dataProp: 'sortOrder', dataType: 'number' },
        { title: 'Begin date', dataProp: 'beginDate', dataType: 'datetime' },
        { title: 'End date', dataProp: 'endDate', dataType: 'datetime' },
    ];

    if (isAuthorizedFor(ApplicationFunctions.EditColor)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }],
            });
    }

    return (
        <div className='main-content'>
            <Form title='Colors' footer={(
                <ButtonBar offset={2}>
                    <Button text='Search' {...getSubmitButtonProps()} />
                    <Button text='Clear' type='button' onClick={setDefaultCriteria} />
                </ButtonBar>
            )}>
                <Container fluid>
                    <TextboxField {...getFieldProps('quickSearch')} />
                </Container>
            </Form>
            <div className="card" style={{ margin: '0 12px', padding: 12 }}>
                <DataTable
                    name='dtColors'
                    tableData={data}
                    colInfos={colInfos}
                    navigateTitle='Color'
                    navigateUrl='/plm/itemsetup/color/'
                />
            </div>
            {showPopup && (<Colors_popup_AddColor show={showPopup} onHide={() => { setShowPopup(false); getTableData(formData); }} />)}
        </div>
    );
}
export default Colors;